import React,{useState,useEffect} from 'react'
import { useForm } from 'react-hook-form';
import {toast} from 'react-toastify'
import clinicService from '../../../../../services/clinic.service';

function SocialLinkCard({linkitem,updatelinks,getLinks}) {
   const [edit, setEdit] = useState(false)

   const { register, handleSubmit, formState:{errors} } = useForm(
    {
        defaultValues:{
            id:linkitem.id,
            type:linkitem.type,
            clinicId:linkitem.clinicId,
            link:linkitem.link
        }
    })
    const onSubmit = (data)=>{
            //update social link
            clinicService.updateSocialLinks(linkitem.clinicId,data)
            .then(res=>{
            
              //updatelinks(res.data)
              getLinks()
              setEdit(!edit)
              toast.success("Updated Link",{
                position:toast.POSITION.BOTTOM_RIGHT
              })
            })
            .catch(err=>{
              toast.error("Error Updating Social Link",{
                position:toast.POSITION.BOTTOM_RIGHT
              })
            })

    }

    const handleDelete = (cid,lid)=>{
      //console.log("Delete Link : "+lid+" clinic:"+cid)
      clinicService.deleteSocialLink(cid,lid)
      .then(res=>{
        //console.log(res)
        getLinks()
        toast.success("Deleted Link",{
          position:toast.POSITION.BOTTOM_RIGHT
        })
      })
      .catch(err=>{
        //console.log(err)
        toast.error("Error Deleting Social Link",{
          position:toast.POSITION.BOTTOM_RIGHT
        })
      })
    }
    return (
    <>
            <div className="col-sm-4">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between">
                            <h5 className="card-title">{linkitem.type}</h5>
                            <div className='mt-3'>
                                <button className="btn" onClick={()=>setEdit(!edit)}>{edit? "Cancel" :<i className="bi bi-pencil-square"></i>}</button>
                            </div>
                        </div>
                       {!edit?
                        <h6 className="card-subtitle text-body-secondary">{linkitem.link}</h6>
                        : <>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="mb-2">
                                    <input type="text" className="form-control" {...register("link")}/>
                                    <input type="hidden" {...register("id")} />
                                    <input type="hidden" {...register("clinicId")} />
                                    <input type="hidden" {...register('type')} />
                                </div>
                                 <div className="d-flex justify-content-between">
                                    <button type="submit" className="btn btn-primary btn-sm">Update</button>
                                    <button className="btn btn-danger btn-sm" onClick={()=>handleDelete(linkitem.clinicId,linkitem.id)}>Delete</button>
                                 </div>
                                
                            </form>
                        </> }
                    </div>
                </div>
                
            </div>
    </>
  )
}

export default SocialLinkCard